import React from 'react'
import { Box, Flex } from '@chakra-ui/react'
import styled from '@emotion/styled'

// TODO [FEATURE-638]: Re-write these component with Chakra theme.

const Input = styled.input`
    position: absolute;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    
    & ~ label {
        width: 100%;
        cursor: pointer;
    }
`

const ElementWrapper = styled.div`
    display: block;
    flex: 1 1 0;
    white-space: nowrap;
    user-select: none;

    &:hover input ~ label {
        background-color: #eee;
        color: black;
    }

    & input:checked ~ label,
    &:hover input:checked ~ label {
        background-color: #6c77ed;
        color: white;
    }
`

function getId(option: any, name: string) {
    return name + option.label
}

function inputProps(option: any, currentValue: any, name: string) {
    const id = getId(option, name)

    return {
        name,
        id,
        key: id,
        value: option.value,
        checked: option.value === currentValue,
    }
}

function extractValue(value: string) {
    return value === 'false' ? false : value === 'true' ? true : value
}

const paddingSizes: any = {
    sm: { base: '10px', md: '10px 12px' },
    md: { base: '12px', md: '12px 20px' },
}

const fontSizes: any = {
    sm: '14px',
    md: '16px',
}

export const ToggleSwitcher = ({ field, options }: any) => {
    const { name, value, onChange, onFocus, size = 'md' } = field

    return (
      <Flex
        display={'inline-flex'}
        width={'fit-content'}
        minWidth={{ base: '100%', md: 'auto' }}
        borderWidth={'1px'}
        borderColor={'gray.dividers'}
        borderRadius={'12px'}
      >
          {options?.map((o: any) => {
              const id = name + o.label

              const { key, ...otherProps } = inputProps(o, value, name)

              return (
                <ElementWrapper key={key}>
                    <Input
                      {...otherProps}
                      type="radio"
                      onChange={e => onChange(extractValue(e.target.value))}
                      onFocus={onFocus}
                    />
                    <Box
                      as={'label'}
                      htmlFor={id}
                      display={'inline-flex'}
                      alignItems={'center'}
                      justifyContent={'center'}
                      borderRadius={'12px'}
                      lineHeight={'22px'}
                      cursor={'pointer'}
                      padding={paddingSizes[size]}
                      fontSize={fontSizes[size]}
                      fontWeight="medium"
                    >
                        {o.label}
                    </Box>
                </ElementWrapper>
              )
          })}
      </Flex>
    )
}
